<mat-toolbar class='secondary outer'>
  @if (_scrollingEnabled) {
    <button class='breadcrumb-item arrow' mat-raised-button (click)='setScrollOffset(40)'>
      <mat-icon>chevron_left</mat-icon>
    </button>
  }
  <div class='breadcrumb-container' #breadCrumbContainer>
    <div [ngClass]='{breadcrumbWithNoLeftPadding: _scrollingEnabled, breadcrumb: !_scrollingEnabled, }' [style.left]="scrollOffset + 'px'">
      <button class='breadcrumb-item' matChip (click)="navTo('')">
        <mat-icon>home</mat-icon>
      </button>
      @for (el of elements; track el) {
        <button class='breadcrumb-item' matChip (click)="navTo(el.link)">{{ el.name }}</button>
      }
    </div>
  </div>
  @if (_scrollingEnabled) {
    <button class='breadcrumb-item arrow' mat-raised-button (click)='setScrollOffset(-40)'>
      <mat-icon>chevron_right</mat-icon>
    </button>
  }
</mat-toolbar>
